webpackJsonp([138599828140278],{

/***/ 794:
/***/ (function(module, exports) {

	module.exports = {"data":{"themenJson":{"thema":"high","monat_num":10,"thema_cover_uri":"10_2005.jpg","jahr":2005,"monat":"October","id":"thema_44","issue_date":"200510","moving_image_count":1,"still_image_count":2,"textz_count":3,"soundz_count":0}},"pathContext":{"id":"thema_44"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200510-6d378cd71dd8f4598eb2.js